import React from "react";
import { Route, Switch } from "react-router-dom";
import ForgotPin from "../Workspaces/ForgotPin";

import Login from '../Workspaces/Login';
import Register from "../Workspaces/Register";
import Salesforce from '../Workspaces/Salesforce';
import TermsAndConditions from '../Workspaces/TermsAndConditions'

class WorkspaceRoutes extends React.Component {
    
    render() {
        return (
            <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/salesforce" component={Salesforce} />
                <Route path="/termsandconditions" component={TermsAndConditions} />
                <Route path="/register/:sfId/:unitId" component={Register} />
                <Route path="/forgotpin" component={ForgotPin} />
                <Route path="*"
                    render={function () {
                        return <h1>Not Found</h1>;
                    }}
                />
            </Switch>
        )
    }
}

export default WorkspaceRoutes;